import { Middleware } from 'redux'
import thunk from 'redux-thunk'

const middleware: Middleware[] = [thunk]

export { middleware }
